import { Injectable } from "@angular/core";
import { DynamicField, RuleCondition } from "../interfaces/dynamic-form-model";

@Injectable({ providedIn: 'root' })
export class RuleEngineService {

    evaluate(
        field: DynamicField,
        formValue: any
    ): {
        visible: boolean;
        readonly: boolean;
        required: boolean;
        label: string
    } {

        const result = {
            visible: field.visible ?? false,
            readonly: field.readonly ?? false,
            required: field.required ?? false,
            label: field.label || ''
        };

        if (!field.rules?.length) {
            return result;
        }

        for (const rule of field.rules) {
            const matched =
                (rule.conditions?.every(c => this.evaluateCondition(c, formValue)) ?? false) ||
                (rule.anyOf?.some(c => this.evaluateCondition(c, formValue)) ?? false);

            if (!matched) continue;

            switch (rule.action) {
                case "setLabel":
                    result.label = rule.value
                    break;
                case 'hidden':
                    result.visible = false;
                    break;

                case 'visible':
                    result.visible = true;
                    break;

                case 'readonly':
                    result.readonly = true;
                    break;

                case 'enable':
                    result.readonly = false;
                    break;

                case 'required':
                    result.required = true;
                    break;
            }
        }

        return result;
    }

    private evaluateCondition(cond: RuleCondition, formValue: any): boolean {
        const actual = formValue?.[cond.field];

        switch (cond.operator) {
            case 'equals':
                return actual === cond.value;

            case 'notEquals':
                return actual !== cond.value;

            case 'in':
                return cond.value?.includes(actual);

            case 'notIn':
                return !cond.value?.includes(actual);

            case 'exists':
                return actual !== null && actual !== undefined;

            default:
                return false;
        }
    }
}